import { useField } from '@framework/form/field/useField.tsx';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

/**
 * # RETROCOMPATIBILITÀ
 * con PR #1541 è stato introdotto il
 * campo labelFields per gestire la label dei widget asyncSelect come insieme di valori anziché
 * riferimento a un unico campo.
 *
 * Utilizziamo questo widget in configurazione per garantire la retrocompatibilità con i widget
 * precedentemente configurati. Andiamo quindi a sostituire il valore dei labelFields con un array
 * contenente il valore di labelField, rimuovendo il valore di labelField.
 */
export function useLabelFieldFixer() {
  const labelFieldsValue = useWatch({ name: `labelFields` });
  const labelFieldValue = useWatch({ name: `labelField` });

  const labelFields = useField('labelFields');
  const labelField = useField('labelField');

  useEffect(() => {
    if (labelFieldValue && !labelFieldsValue?.length) {
      // biome-ignore format: <tbd>
      console.log("[LabelFieldFixer] Sostiuzione valore labelFields con array contenente il valore di labelField", { labelFieldValue, labelFieldsValue });
      labelFields.setValue([labelFieldValue]);
      labelField.setValue(null);
    }
  }, [labelField, labelFieldValue, labelFields, labelFieldsValue]);
}
